import { render, staticRenderFns } from "./TierProgressBar.vue?vue&type=template&id=5546205c&scoped=true&"
import script from "./TierProgressBar.vue?vue&type=script&lang=ts&"
export * from "./TierProgressBar.vue?vue&type=script&lang=ts&"
import style0 from "./TierProgressBar.vue?vue&type=style&index=0&id=5546205c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5546205c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5546205c')) {
      api.createRecord('5546205c', component.options)
    } else {
      api.reload('5546205c', component.options)
    }
    module.hot.accept("./TierProgressBar.vue?vue&type=template&id=5546205c&scoped=true&", function () {
      api.rerender('5546205c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "common/src/components/TierProgressBar.vue"
export default component.exports